import Cookies from "js-cookie";

export function getAtlCohortIdFromCookie() {
    let atlCohortId;
    try {
        const cookie = JSON.parse(Cookies.get("atlCohort") || "");
        atlCohortId = cookie["bucketAll"].index;
    } catch (e) {
        atlCohortId = "";
        console.warn("Cannot parse atlCohort cookie", e);
    }
    return atlCohortId;
}
